const HomeAdmin = ()=> import('./components/admin/Home');
const SocialNetworksList = ()=> import('./components/admin/socialNetworks/List');
const SocialNetworksForm = ()=> import('./components/admin/socialNetworks/Form');
const AuthorsList = ()=> import('./components/admin/authors/List');
const AuthorsForm = ()=> import('./components/admin/authors/Form');
const ArtworksList = ()=> import('./components/admin/artworks/List');
const ArtworksForm = ()=> import('./components/admin/artworks/Form');
const RolesList = ()=> import('./components/admin/roles/List');
const RolesForm = ()=> import('./components/admin/roles/Form');
const UsersList = ()=> import('./components/admin/users/List');
const UsersForm = ()=> import('./components/admin/users/Form');
const CountriesList = ()=> import('./components/admin/countries/List');
const CountriesForm = ()=> import('./components/admin/countries/Form');
const UserAddressesList = ()=> import('./components/admin/userAddresses/List');
const UserAddressesForm = ()=> import('./components/admin/userAddresses/Form');
const UserAddressTypesList = ()=> import('./components/admin/userAddressTypes/List');
const UserAddressTypesForm = ()=> import('./components/admin/userAddressTypes/Form');
const CategoriesList = ()=> import('./components/admin/categories/List');
const CategoriesForm = ()=> import('./components/admin/categories/Form');
const TaxesList = ()=> import('./components/admin/taxes/List');
const TaxesForm = ()=> import('./components/admin/taxes/Form');
const HolidaysList = ()=> import('./components/admin/holidays/List');
const HolidaysForm = ()=> import('./components/admin/holidays/Form');
const TimeSlotsList = ()=> import('./components/admin/timeSlots/List');
const TimeSlotsForm = ()=> import('./components/admin/timeSlots/Form');
const ShoppingCartsList = ()=> import('./components/admin/shoppingCarts/List');
const ShoppingCartsForm = ()=> import('./components/admin/shoppingCarts/Form');
const ExhibitionsList = ()=> import('./components/admin/exhibitions/List');
const ExhibitionsForm = ()=> import('./components/admin/exhibitions/Form');
const InvoicesList = ()=> import('./components/admin/invoices/List');
const InvoicesForm = ()=> import('./components/admin/invoices/Form');
const PricesList = ()=> import('./components/admin/prices/List');
const PricesForm = ()=> import('./components/admin/prices/Form');
const ProductsList = ()=> import('./components/admin/products/List');
const ProductsForm = ()=> import('./components/admin/products/Form');
const BookingsList = ()=> import('./components/admin/bookings/List');
const ModalsList = ()=> import('./components/admin/modals/List');
const ModalsForm = ()=> import('./components/admin/modals/Form');
const PhotographyCompetitionForm = ()=> import('./components/admin/photography_competition/Form.vue');
const RapitaEbreForm = ()=> import('./components/admin/rapita_ebre/Form.vue');
const ReservationsTextForm = ()=> import('./components/admin/reservations_text/Form.vue');

const InicioTextForm = ()=> import('./components/admin/inicio_text/Form.vue');
/**
 * Frontend
 */
const Home = ()=> import('./components/frontend/Home');
const RapitaEbroDelta = ()=> import('./components/frontend/statics/RapitaEbroDelta');
const FindUs = ()=> import('./components/frontend/statics/FindUs');
const VideoTour = ()=> import('./components/frontend/statics/VideoTour');
const SulptureParkGallery = ()=> import('./components/frontend/statics/SulptureParkGallery');
const RentPark = ()=> import('./components/frontend/statics/RentPark');
const CategoriesListFrontend = ()=> import('./components/frontend/categories/List');
const ArtworksListFrontend = ()=> import('./components/frontend/artworks/List');
const ArtworksViewFrontend = ()=> import('./components/frontend/artworks/View');
const AuthorsListFrontend = ()=> import('./components/frontend/authors/List');
const AuthorsViewFrontend = ()=> import('./components/frontend/authors/View');
const BookingsFrontend = ()=> import('./components/frontend/statics/Bookings');
const CartFrontend = ()=> import('./components/frontend/shopping/Cart');
const CheckoutFrontend = ()=> import('./components/frontend/shopping/Checkout');
const CompleteFrontend = ()=> import('./components/frontend/shopping/Complete');
const UserProfileFrontend = ()=> import('./components/frontend/profile/UserProfile');
const ContactFrontend = ()=> import('./components/frontend/contact/contact');
const Error404 = ()=> import('./components/frontend/errors/404');
const ExhibitionsListFrontend = ()=> import('./components/frontend/exhibitions/List');
const ExhibitionsViewFrontend = ()=> import('./components/frontend/exhibitions/View');
const CookiesViewFrontend = () => import('./components/frontend/cookies/View');
const PrivacyPolicyViewFrontend = ()=> import('./components/frontend/statics/PrivacyPolicy');
const LegalPolicyViewFrontend = ()=> import('./components/frontend/statics/LegalPolicy');
const ShopFrontend = ()=> import('./components/frontend/shop/List');
const PhotographyCompetitionFrontend = ()=> import('./components/frontend/statics/PhotographyCompetition');
const RapitaEbreFrontend = ()=> import('./components/frontend/statics/RapitaEbre');
const DiscountCodesList = ()=> import('./components/admin/discountcodes/List');
const DiscountCodesForm = ()=> import('./components/admin/discountcodes/Form');
/*Auth*/
const Login = ()=> import('./components/frontend/auth/Login');
const ResetPasswordForm = ()=> import('./components/frontend/auth/ResetPasswordForm');
export const adminRoutes = [
    {
        name: 'admin',
        path: '/admin',
        component: HomeAdmin
    },
    {
        name: 'socialNetworksList',
        path: '/admin/social-networks/',
        component: SocialNetworksList
    },

    {
        name: 'socialNetworksCreate',
        path: '/admin/social-networks/create',
        component: SocialNetworksForm
    },
    {
        name: 'socialNetworksEdit',
        path: '/admin/social-networks/:id/edit',
        component: SocialNetworksForm
    },
    {
        name: 'socialNetworksDelete',
        path: '/admin/social-networks/:id/delete',
    },
    {
        name: 'authorsList',
        path: '/admin/authors/',
        component: AuthorsList
    },
    {
        name: 'authorsCreate',
        path: '/admin/authors/create',
        component: AuthorsForm
    },
    {
        name: 'authorsEdit',
        path: '/admin/authors/:id/edit',
        component: AuthorsForm
    },
    {
        name: 'authorsDelete',
        path: '/admin/authors/:id/delete',
    },
    {
        name: 'rolesList',
        path: '/admin/roles/',
        component: RolesList
    },
    {
        name: 'rolesCreate',
        path: '/admin/roles/create',
        component: RolesForm
    },
    {
        name: 'rolesEdit',
        path: '/admin/roles/:id/edit',
        component: RolesForm
    },
    {
        name: 'rolesDelete',
        path: '/admin/roles/:id/delete',
    },
    {
        name: 'usersList',
        path: '/admin/users/',
        component: UsersList
    },
    {
        name: 'usersCreate',
        path: '/admin/users/create',
        component: UsersForm
    },
    {
        name: 'usersEdit',
        path: '/admin/users/:id/edit',
        component: UsersForm
    },
    {
        name: 'usersDelete',
        path: '/admin/users/:id/delete',
    },
    {
        name: 'countriesList',
        path: '/admin/countries/',
        component: CountriesList
    },
    {
        name: 'countriesCreate',
        path: '/admin/countries/create',
        component: CountriesForm
    },
    {
        name: 'countriesEdit',
        path: '/admin/countries/:id/edit',
        component: CountriesForm
    },
    {
        name: 'countriesDelete',
        path: '/admin/countries/:id/delete',
    },
    {
        name: 'artworksList',
        path: '/admin/artworks/',
        component: ArtworksList
    },
    {
        name: 'artworksCreate',
        path: '/admin/artworks/create',
        component: ArtworksForm
    },
    {
        name: 'artworksEdit',
        path: '/admin/artworks/:id/edit',
        component: ArtworksForm
    },
    {
        name: 'artworksDelete',
        path: '/admin/artworks/:id/delete',
    },
    {
        name: 'userAddressesList',
        path: '/admin/users/:user/user-addresses',
        component: UserAddressesForm
    },
    /*{
        name: 'userAddressesList',
        path: '/admin/users/user-addresses',
        component: UserAddressesList
    },*/
    {
        name: 'userAddressesCreate',
        path: '/admin/users/:user/user-addresses/create',
        component: UserAddressesForm
    },
    {
        name: 'userAddressTypesList',
        path: '/admin/user-address-types/',
        component: UserAddressTypesList
    },
    {
        name: 'userAddressTypesCreate',
        path: '/admin/user-address-types/create',
        component: UserAddressTypesForm
    },
    {
        name: 'userAddressTypesEdit',
        path: '/admin/user-address-types/:id/edit',
        component: UserAddressTypesForm
    },
    {
        name: 'userAddressTypesDelete',
        path: '/admin/user-address-types/:id/delete',
    },
    {
        name: 'categoriesList',
        path: '/admin/categories/',
        component: CategoriesList
    },
    {
        name: 'categoriesCreate',
        path: '/admin/categories/create',
        component: CategoriesForm
    },
    {
        name: 'categoriesEdit',
        path: '/admin/categories/:id/edit',
        component: CategoriesForm
    },
    {
        name: 'categoriesDelete',
        path: '/admin/categories/:id/delete',
    },
    {
        name: 'taxesList',
        path: '/admin/taxes/',
        component: TaxesList
    },
    {
        name: 'taxesCreate',
        path: '/admin/taxes/create',
        component: TaxesForm
    },
    {
        name: 'taxesEdit',
        path: '/admin/taxes/:id/edit',
        component: TaxesForm
    },
    {
        name: 'taxesDelete',
        path: '/admin/taxes/:id/delete',
    },
    {
        name: 'discountcodesList',
        path: '/admin/discountcodes/',
        component: DiscountCodesList
    },
    {
        name: 'discountcodesCreate',
        path: '/admin/discountcodes/create',
        component: DiscountCodesForm
    },
    {
        name: 'discountcodesEdit',
        path: '/admin/discountcodes/:id/edit',
        component: DiscountCodesForm
    },
    {
        name: 'discountcodesDelete',
        path: '/admin/discountcodes/:id/delete',
    },
    {
        name: 'holidaysList',
        path: '/admin/holidays/',
        component: HolidaysList
    },
    {
        name: 'holidaysCreate',
        path: '/admin/holidays/create',
        component: HolidaysForm
    },
    {
        name: 'holidaysEdit',
        path: '/admin/holidays/:id/edit',
        component: HolidaysForm
    },
    {
        name: 'holidaysDelete',
        path: '/admin/holidays/:id/delete',
    },
    {
        name: 'timeSlotsList',
        path: '/admin/time-slots/',
        component: TimeSlotsList
    },
    {
        name: 'timeSlotsCreate',
        path: '/admin/time-slots/create',
        component: TimeSlotsForm
    },
    {
        name: 'timeSlotsEdit',
        path: '/admin/time-slots/:id/edit',
        component: TimeSlotsForm
    },
    {
        name: 'timeSlotsDelete',
        path: '/admin/time-slots/:id/delete',
    },
    {
        name: 'shoppingCartsList',
        path: '/admin/shopping-carts/',
        component: ShoppingCartsList
    },
    {
        name: 'shoppingCartsCreate',
        path: '/admin/shopping-carts/create',
        component: ShoppingCartsForm
    },
    {
        name: 'shoppingCartsEdit',
        path: '/admin/shopping-carts/:key/edit',
        component: ShoppingCartsForm
    },
    {
        name: 'ShoppingCartsDelete',
        path: '/admin/shopping-carts/:key/delete',
    },
    {
        name: 'exhibitionsList',
        path: '/admin/exhibitions/',
        component: ExhibitionsList
    },
    {
        name: 'exhibitionsCreate',
        path: '/admin/exhibitions/create',
        component: ExhibitionsForm
    },
    {
        name: 'exhibitionsEdit',
        path: '/admin/exhibitions/:id/edit',
        component: ExhibitionsForm
    },
    {
        name: 'exhibitionsDelete',
        path: '/admin/exhibitions/:id/delete',
    },
    {
        name: 'invoicesList',
        path: '/admin/invoices/',
        component: InvoicesList
    },
    {
        name: 'invoicesCreate',
        path: '/admin/invoices/create',
        component: InvoicesForm
    },
    {
        name: 'invoicesEdit',
        path: '/admin/invoices/:id/edit',
        component: InvoicesForm
    },
    {
        name: 'invoicesDelete',
        path: '/admin/invoices/:id/delete',
    },
    {
        name: 'pricesList',
        path: '/admin/prices/',
        component: PricesList
    },
    {
        name: 'pricesCreate',
        path: '/admin/prices/create',
        component: PricesForm
    },
    {
        name: 'pricesEdit',
        path: '/admin/prices/:id/edit',
        component: PricesForm
    },
    {
        name: 'pricesDelete',
        path: '/admin/prices/:id/delete',
    },
    {
        name: 'productsList',
        path: '/admin/products/',
        component: ProductsList
    },
    {
        name: 'productsCreate',
        path: '/admin/products/create',
        component: ProductsForm
    },
    {
        name: 'productsEdit',
        path: '/admin/products/:id/edit',
        component: ProductsForm
    },
    {
        name: 'productsDelete',
        path: '/admin/products/:id/delete',
    },
    {
        name: 'bookingsList',
        path: '/admin/bookings/',
        component: BookingsList
    },
    {
        name: 'modalsList',
        path: '/admin/modals/',
        component: ModalsList
    },
    {
        name: 'modalsCreate',
        path: '/admin/modals/create',
        component: ModalsForm
    },
    {
        name: 'modalsEdit',
        path: '/admin/modals/:id/edit',
        component: ModalsForm
    },
    {
        name: 'modalsDelete',
        path: '/admin/modals/:id/delete',
    },
    {
        name: 'photographyCompetitionForm',
        path: '/admin/content-edit/',
        component: PhotographyCompetitionForm
    },
    {
        name: 'rapitaEbreForm',
        path: '/admin/rapita-ebre-form/',
        component: RapitaEbreForm
    },
    {
        name: 'reservationsTextForm',
        path: '/admin/reservations-text/',
        component: ReservationsTextForm
    },
    {
        name: 'inicioTextForm',
        path: '/admin/inicio-text/',
        component: InicioTextForm
    },
];

let fRoutes = [];
fRoutes['es'] = [
    {
        name: 'home',
        path: '/',
        component: Home,
        meta: {
            title: 'siteName',
            metaTags: [
                {
                    name: 'description',
                    content: 'homeDescription'
                },
                {
                    property: 'og:description',
                    content: 'homeDescription'
                }
            ]
        }
    },
    {
        name: 'login',
        path: '/acceder',
        component: Login,
        meta: {
            title: 'loginRegister',
            metaTags: [
                {
                    name: 'description',
                    content: 'homeDescription'
                },
                {
                    property: 'og:description',
                    content: 'homeDescription'
                }
            ]
        }
    },
    {
        name: 'ResetPassword',
        path: '/reset-password/:token',
        component: ResetPasswordForm,
        meta: {
            title: 'reset_password',
            metaTags: [
                {
                    name: 'description',
                    content: 'resetPasswordDescription'
                },
                {
                    property: 'og:description',
                    content: 'resetPasswordDescription'
                }
            ]
        }
    },
    {
        name: 'categoriesListFrontend',
        path: '/piezas-arte/categorias',
        component: CategoriesListFrontend,
        meta: {
            title: 'artworks',
            metaTags: [
                {
                    name: 'description',
                    content: 'artworksDescription'
                },
                {
                    property: 'og:description',
                    content: 'artworksDescription'
                }
            ]
        }
    },
    {
        name: 'artworksListFrontend',
        path: '/piezas-arte',
        component: ArtworksListFrontend,
        meta: {
            title: 'artworks',
            metaTags: [
                {
                    name: 'description',
                    content: 'artworksDescription'
                },
                {
                    property: 'og:description',
                    content: 'artworksDescription'
                }
            ]
        }
    },
    {
        name: 'artworksViewFrontend',
        path: '/piezas-arte/:id',
        component: ArtworksViewFrontend,
        meta: {
            title: 'artwork',
            metaTags: [
                {
                    name: 'description',
                    content: 'artworksDescription'
                },
                {
                    property: 'og:description',
                    content: 'artworksDescription'
                }
            ]
        }
    },
    {
        name: 'authorsListFrontend',
        path: '/artistas',
        component: AuthorsListFrontend,
        meta: {
            title: 'authors',
            metaTags: [
                {
                    name: 'description',
                    content: 'authorsDescription'
                },
                {
                    property: 'og:description',
                    content: 'authorsDescription'
                }
            ]
        }
    },
    {
        name: 'authorsViewFrontend',
        path: '/artistas/:slug',
        component: AuthorsViewFrontend,
        meta: {
            title: 'author',
            metaTags: [
                {
                    name: 'description',
                    content: 'authorsDescription'
                },
                {
                    property: 'og:description',
                    content: 'authorsDescription'
                }
            ]
        }
    },
    {
        name: 'bookingsFrontend',
        path: '/reservar',
        component: BookingsFrontend,
        meta: {
            title: 'bookings',
            metaTags: [
                {
                    name: 'description',
                    content: 'bookingsDescription'
                },
                {
                    property: 'og:description',
                    content: 'bookingsDescription'
                }
            ]
        }
    },
    {
        name: 'ShoppingCart',
        path: '/carrito-compra',
        component: CartFrontend,
        meta: {
            title: 'ShoppingCart',
            metaTags: [
                {
                    name: 'description',
                    content: 'cartDescription'
                },
                {
                    property: 'og:description',
                    content: 'cartDescription'
                }
            ]
        }
    },
    {
        name: 'CheckoutCart',
        path: '/carrito-compra/pago',
        component: CheckoutFrontend,
        meta: {
            title: 'CheckoutCart',
            metaTags: [
                {
                    name: 'description',
                    content: 'checkoutDescription'
                },
                {
                    property: 'og:description',
                    content: 'checkoutDescription'
                }
            ]
        }
    },
    {
        name: 'CompleteCart',
        path: '/carrito-compra/:key/completado',
        component: CompleteFrontend,
        meta: {
            title: 'CompleteCart',
            metaTags: [
                {
                    name: 'description',
                    content: 'completeDescription'
                },
                {
                    property: 'og:description',
                    content: 'completeDescription'
                }
            ]
        }
    },
    {
        name: 'UserProfile',
        path: '/perfil',
        component: UserProfileFrontend,
        meta: {
            title: 'UserProfile',
            metaTags: [
                {
                    name: 'description',
                    content: 'profileDescription'
                },
                {
                    property: 'og:description',
                    content: 'profileDescription'
                }
            ]
        }
    },
    {
        name: 'ContactFrontend',
        path: '/contactar',
        component: ContactFrontend,
        meta: {
            title: 'Contact',
            metaTags: [
                {
                    name: 'description',
                    content: 'contactDescription'
                },
                {
                    property: 'og:description',
                    content: 'contactDescription'
                }
            ]
        }
    },
    {
        name: 'RapitaEbroDelta',
        path: '/rapita-delta-del-ebro',
        component: RapitaEbroDelta,
        meta: {
            title: 'RapitaEbroDelta',
            metaTags: [
                {
                    name: 'description',
                    content: 'RapitaEbroDeltaDescription'
                },
                {
                    property: 'og:description',
                    content: 'RapitaEbroDeltaDescription'
                }
            ]
        }
    },
    {
        name: 'FindUs',
        path: '/encuentranos',
        component: FindUs,
        meta: {
            title: 'FindUs',
            metaTags: [
                {
                    name: 'description',
                    content: 'FindUsDescription'
                },
                {
                    property: 'og:description',
                    content: 'FindUsDescription'
                }
            ]
        }
    },
    {
        name: 'VideoTour',
        path: '/video-tour',
        component: VideoTour,
        meta: {
            title: 'VideoTour',
            metaTags: [
                {
                    name: 'description',
                    content: 'VideoTourDescription'
                },
                {
                    property: 'og:description',
                    content: 'VideoTourDescription'
                }
            ]
        }
    },
    {
        name: 'SulptureParkGallery',
        path: '/parque-esculturas-galeria',
        component: SulptureParkGallery,
        meta: {
            title: 'SulptureParkGallery',
            metaTags: [
                {
                    name: 'description',
                    content: 'SulptureParkGalleryDescription'
                },
                {
                    property: 'og:description',
                    content: 'SulptureParkGalleryDescription'
                }
            ]
        }
    },
    {
        name: 'exhibitionsListFrontend',
        path: '/exhibiciones',
        component: ExhibitionsListFrontend,
        meta: {
            title: 'exhibitions',
            metaTags: [
                {
                    name: 'description',
                    content: 'ExhibitionsDescription'
                },
                {
                    property: 'og:description',
                    content: 'ExhibitionsDescription'
                }
            ]
        }
    },
    {
        name: 'exhibitionsViewFrontend',
        path: '/exhibiciones/:id',
        component: ExhibitionsViewFrontend,
        meta: {
            title: 'exhibitions',
            metaTags: [
                {
                    name: 'description',
                    content: 'ExhibitionsDescription'
                },
                {
                    property: 'og:description',
                    content: 'ExhibitionsDescription'
                }
            ]
        }
    },
    {
        name: 'RentPark',
        path: '/alquilar-el-parque',
        component: RentPark,
        meta: {
            title: 'rent_park',
            metaTags: [
                {
                    name: 'description',
                    content: 'RentParkDescription'
                },
                {
                    property: 'og:description',
                    content: 'RentParkDescription'
                }
            ]
        }
    },
    {
        name: 'cookiesViewFrontend',
        path: '/politica_cookies',
        component: CookiesViewFrontend,
        meta: {
            title: 'cookies',
            metaTags: [
                {
                    name: 'description',
                    content: 'CookiesDescription'
                },
                {
                    property: 'og:description',
                    content: 'CookiesDescription'
                }
            ]
        }
    },
    {
        name: 'privacyPolicyViewFrontend',
        path: '/politica-privacidad',
        component: PrivacyPolicyViewFrontend,
        meta: {
            title: 'privacy_policy',
            metaTags: [
                {
                    name: 'description',
                    content: 'PrivacyPolicyDescription'
                },
                {
                    property: 'og:description',
                    content: 'PrivacyPolicyDescription'
                }
            ]
        }
    },
    {
        name: 'legalPolicyViewFrontend',
        path: '/aviso-legal',
        component: LegalPolicyViewFrontend,
        meta: {
            title: 'legal_policy',
            metaTags: [
                {
                    name: 'description',
                    content: 'LegalPolicyDescription'
                },
                {
                    property: 'og:description',
                    content: 'LegalPolicyDescription'
                }
            ]
        }
    },
    //definir avanç
    {
        name: 'Error404',
        path: '/',
        component: Error404,
        meta: {
            title: '404',
            metaTags: [
                {
                    name: 'description',
                    content: 'notFound'
                },
                {
                    property: 'og:description',
                    content: 'notFound'
                }
            ]
        }
    },
    {
        name: 'shopFrontend',
        path: '/compra-arte',
        component: ShopFrontend,
        meta: {
            title: 'artworks',
            metaTags: [
                {
                    name: 'description',
                    content: 'shopDescription'
                },
                {
                    property: 'og:description',
                    content: 'shopDescription'
                }
            ]
        }
    },
    {
        name: 'photographyCompetitionFrontend',
        path: '/contenido',
        component: PhotographyCompetitionFrontend,
        meta: {
            title: 'photography_competition',
            metaTags: [
                {
                    name: 'description',
                    content: 'photographyCompetitionDescription'
                },
                {
                    property: 'og:description',
                    content: 'photographyCompetitionDescription'
                }
            ]
        }
    },
    {
        name: 'rapitaEbreFrontend',
        path: '/rapita-ebro',
        component: RapitaEbreFrontend,
        meta: {
            title: 'RapitaEbroDelta',
            metaTags: [
                {
                    name: 'description',
                    content: 'rapitaEbreDescription'
                },
                {
                    property: 'og:description',
                    content: 'rapitaEbreDescription'
                }
            ]
        }
    },

];
fRoutes['ca'] = [
    {
        name: 'home',
        path: '/',
        component: Home,
        meta: {
            title: 'siteName',
            metaTags: [
                {
                    name: 'description',
                    content: 'homeDescription'
                },
                {
                    property: 'og:description',
                    content: 'homeDescription'
                }
            ]
        }
    },
    {
        name: 'login',
        path: '/accedir',
        component: Login,
        meta: {
            title: 'loginRegister',
            metaTags: [
                {
                    name: 'description',
                    content: 'homeDescription'
                },
                {
                    property: 'og:description',
                    content: 'homeDescription'
                }
            ]
        }
    },
    {
        name: 'ResetPassword',
        path: '/reset-password/:token',
        component: ResetPasswordForm,
        meta: {
            title: 'reset_password',
            metaTags: [
                {
                    name: 'description',
                    content: 'resetPasswordDescription'
                },
                {
                    property: 'og:description',
                    content: 'resetPasswordDescription'
                }
            ]
        }
    },
    {
        name: 'categoriesListFrontend',
        path: '/peces-art/categories',
        component: CategoriesListFrontend,
        meta: {
            title: 'artworks',
            metaTags: [
                {
                    name: 'description',
                    content: 'artworksDescription'
                },
                {
                    property: 'og:description',
                    content: 'artworksDescription'
                }
            ]
        }
    },
    {
        name: 'artworksListFrontend',
        path: '/peces-art',
        component: ArtworksListFrontend,
        meta: {
            title: 'artworks',
            metaTags: [
                {
                    name: 'description',
                    content: 'artworksDescription'
                },
                {
                    property: 'og:description',
                    content: 'artworksDescription'
                }
            ]
        }
    },
    {
        name: 'artworksViewFrontend',
        path: '/peces-art/:id',
        component: ArtworksViewFrontend,
        meta: {
            title: 'artworks',
            metaTags: [
                {
                    name: 'description',
                    content: 'artworksDescription'
                },
                {
                    property: 'og:description',
                    content: 'artworksDescription'
                }
            ]
        }
    },
    {
        name: 'authorsListFrontend',
        path: '/autors',
        component: AuthorsListFrontend,
        meta: {
            title: 'authors',
            metaTags: [
                {
                    name: 'description',
                    content: 'authorsDescription'
                },
                {
                    property: 'og:description',
                    content: 'authorsDescription'
                }
            ]
        }
    },
    {
        name: 'authorsViewFrontend',
        path: '/autors/:slug',
        component: AuthorsViewFrontend,
        meta: {
            title: 'authors',
            metaTags: [
                {
                    name: 'description',
                    content: 'authorsDescription'
                },
                {
                    property: 'og:description',
                    content: 'authorsDescription'
                }
            ]
        }
    },
    {
        name: 'bookingsFrontend',
        path: '/reservar',
        component: BookingsFrontend,
        meta: {
            title: 'bookings',
            metaTags: [
                {
                    name: 'description',
                    content: 'bookingsDescription'
                },
                {
                    property: 'og:description',
                    content: 'bookingsDescription'
                }
            ]
        }
    },
    {
        name: 'ShoppingCart',
        path: '/cistella-compra',
        component: CartFrontend,
        meta: {
            title: 'ShoppingCart',
            metaTags: [
                {
                    name: 'description',
                    content: 'cartDescription'
                },
                {
                    property: 'og:description',
                    content: 'cartDescription'
                }
            ]
        }
    },
    {
        name: 'CheckoutCart',
        path: '/cistella-compra/pagar',
        component: CheckoutFrontend,
        meta: {
            title: 'CheckoutCart',
            metaTags: [
                {
                    name: 'description',
                    content: 'checkoutDescription'
                },
                {
                    property: 'og:description',
                    content: 'checkoutDescription'
                }
            ]
        }
    },
    {
        name: 'CompleteCart',
        path: '/cistella-compra/:key/completat',
        component: CompleteFrontend,
        meta: {
            title: 'CompleteCart',
            metaTags: [
                {
                    name: 'description',
                    content: 'completeDescription'
                },
                {
                    property: 'og:description',
                    content: 'completeDescription'
                }
            ]
        }
    },
    {
        name: 'UserProfile',
        path: '/perfil',
        component: UserProfileFrontend,
        meta: {
            title: 'UserProfile',
            metaTags: [
                {
                    name: 'description',
                    content: 'profileDescription'
                },
                {
                    property: 'og:description',
                    content: 'profileDescription'
                }
            ]
        }
    },
    {
        name: 'ContactFrontend',
        path: '/contacte',
        component: ContactFrontend,
        meta: {
            title: 'Contact',
            metaTags: [
                {
                    name: 'description',
                    content: 'contactDescription'
                },
                {
                    property: 'og:description',
                    content: 'contactDescription'
                }
            ]
        }
    },
    {
        name: 'RapitaEbroDelta',
        path: '/la-rapita-delta-del-ebre',
        component: RapitaEbroDelta,
        meta: {
            title: 'RapitaEbroDelta',
            metaTags: [
                {
                    name: 'description',
                    content: 'RapitaEbroDeltaDescription'
                },
                {
                    property: 'og:description',
                    content: 'RapitaEbroDeltaDescription'
                }
            ]
        }
    },
    {
        name: 'FindUs',
        path: '/trova-ns',
        component: FindUs,
        meta: {
            title: 'FindUs',
            metaTags: [
                {
                    name: 'description',
                    content: 'FindUsDescription'
                },
                {
                    property: 'og:description',
                    content: 'FindUsDescription'
                }
            ]
        }
    },
    {
        name: 'VideoTour',
        path: '/video-tour',
        component: VideoTour,
        meta: {
            title: 'VideoTour',
            metaTags: [
                {
                    name: 'description',
                    content: 'VideoTourDescription'
                },
                {
                    property: 'og:description',
                    content: 'VideoTourDescription'
                }
            ]
        }
    },
    {
        name: 'SulptureParkGallery',
        path: '/el-parc-escultures',
        component: SulptureParkGallery,
        meta: {
            title: 'SulptureParkGallery',
            metaTags: [
                {
                    name: 'description',
                    content: 'SulptureParkGalleryDescription'
                },
                {
                    property: 'og:description',
                    content: 'SulptureParkGalleryDescription'
                }
            ]
        }
    },
    {
        name: 'exhibitionsListFrontend',
        path: '/exhibicions',
        component: ExhibitionsListFrontend,
        meta: {
            title: 'exhibitions',
            metaTags: [
                {
                    name: 'description',
                    content: 'ExhibitionsDescription'
                },
                {
                    property: 'og:description',
                    content: 'ExhibitionsDescription'
                }
            ]
        }
    },
    {
        name: 'exhibitionsViewFrontend',
        path: '/exhibicions/:id',
        component: ExhibitionsViewFrontend,
        meta: {
            title: 'exhibitions',
            metaTags: [
                {
                    name: 'description',
                    content: 'ExhibitionsDescription'
                },
                {
                    property: 'og:description',
                    content: 'ExhibitionsDescription'
                }
            ]
        }
    },
    {
        name: 'RentPark',
        path: '/alquilar-el-parc',
        component: RentPark,
        meta: {
            title: 'rent_park',
            metaTags: [
                {
                    name: 'description',
                    content: 'RentParkDescription'
                },
                {
                    property: 'og:description',
                    content: 'RentParkDescription'
                }
            ]
        }
    },
    {
        name: 'cookiesViewFrontend',
        path: '/politica-cookies',
        component: CookiesViewFrontend,
        meta: {
            title: 'cookies',
            metaTags: [
                {
                    name: 'description',
                    content: 'CookiesDescription'
                },
                {
                    property: 'og:description',
                    content: 'CookiesDescription'
                }
            ]
        }
    },
    {
        name: 'privacyPolicyViewFrontend',
        path: '/politica-privadesa',
        component: PrivacyPolicyViewFrontend,
        meta: {
            title: 'privacy_policy',
            metaTags: [
                {
                    name: 'description',
                    content: 'PrivacyPolicyDescription'
                },
                {
                    property: 'og:description',
                    content: 'PrivacyPolicyDescription'
                }
            ]
        }
    },
    {
        name: 'legalPolicyViewFrontend',
        path: '/avis-legal',
        component: LegalPolicyViewFrontend,
        meta: {
            title: 'legal_policy',
            metaTags: [
                {
                    name: 'description',
                    content: 'LegalPolicyDescription'
                },
                {
                    property: 'og:description',
                    content: 'LegalPolicyDescription'
                }
            ]
        }
    },
    //definir avanç
    {
        name: 'Error404',
        path: '/404',
        component: Error404,
        meta: {
            title: '404',
            metaTags: [
                {
                    name: 'description',
                    content: 'notFound'
                },
                {
                    property: 'og:description',
                    content: 'notFound'
                }
            ]
        }
    },
    {
        name: 'shopFrontend',
        path: '/compra-art',
        component: ShopFrontend,
        meta: {
            title: 'artworks',
            metaTags: [
                {
                    name: 'description',
                    content: 'shopDescription'
                },
                {
                    property: 'og:description',
                    content: 'shopDescription'
                }
            ]
        }
    },
    {
        name: 'photographyCompetitionFrontend',
        path: '/contingut',
        component: PhotographyCompetitionFrontend,
        meta: {
            title: 'photography_competition',
            metaTags: [
                {
                    name: 'description',
                    content: 'photographyCompetitionDescription'
                },
                {
                    property: 'og:description',
                    content: 'photographyCompetitionDescription'
                }
            ]
        }
    },
    {
        name: 'rapitaEbreFrontend',
        path: '/rapita-ebre',
        component: RapitaEbreFrontend,
        meta: {
            title: 'RapitaEbroDelta',
            metaTags: [
                {
                    name: 'description',
                    content: 'rapitaEbreDescription'
                },
                {
                    property: 'og:description',
                    content: 'rapitaEbreDescription'
                }
            ]
        }
    },
];
fRoutes['en'] = [
    {
        name: 'home',
        path: '/',
        component: Home,
        meta: {
            title: 'siteName',
            metaTags: [
                {
                    name: 'description',
                    content: 'homeDescription'
                },
                {
                    property: 'og:description',
                    content: 'homeDescription'
                }
            ]
        }
    },
    {
        name: 'login',
        path: '/login',
        component: Login,
        meta: {
            title: 'loginRegister',
            metaTags: [
                {
                    name: 'description',
                    content: 'homeDescription'
                },
                {
                    property: 'og:description',
                    content: 'homeDescription'
                }
            ]
        }
    },
    {
        name: 'ResetPassword',
        path: '/reset-password/:token',
        component: ResetPasswordForm,
        meta: {
            title: 'reset_password',
            metaTags: [
                {
                    name: 'description',
                    content: 'resetPasswordDescription'
                },
                {
                    property: 'og:description',
                    content: 'resetPasswordDescription'
                }
            ]
        }
    },
    {
        name: 'categoriesListFrontend',
        path: '/artworks/categories',
        component: CategoriesListFrontend,
        meta: {
            title: 'artworks',
            metaTags: [
                {
                    name: 'description',
                    content: 'artworksDescription'
                },
                {
                    property: 'og:description',
                    content: 'artworksDescription'
                }
            ]
        }
    },
    {
        name: 'artworksListFrontend',
        path: '/artworks',
        component: ArtworksListFrontend,
        meta: {
            title: 'artworks',
            metaTags: [
                {
                    name: 'description',
                    content: 'artworksDescription'
                },
                {
                    property: 'og:description',
                    content: 'artworksDescription'
                }
            ]
        }
    },
    {
        name: 'artworksViewFrontend',
        path: '/artworks/:id',
        component: ArtworksViewFrontend,
        meta: {
            title: 'artworks',
            metaTags: [
                {
                    name: 'description',
                    content: 'artworksDescription'
                },
                {
                    property: 'og:description',
                    content: 'artworksDescription'
                }
            ]
        }
    },
    {
        name: 'authorsListFrontend',
        path: '/authors',
        component: AuthorsListFrontend,
        meta: {
            title: 'authors',
            metaTags: [
                {
                    name: 'description',
                    content: 'authorsDescription'
                },
                {
                    property: 'og:description',
                    content: 'authorsDescription'
                }
            ]
        }
    },
    {
        name: 'authorsViewFrontend',
        path: '/authors/:slug',
        component: AuthorsViewFrontend,
        meta: {
            title: 'authors',
            metaTags: [
                {
                    name: 'description',
                    content: 'authorsDescription'
                },
                {
                    property: 'og:description',
                    content: 'authorsDescription'
                }
            ]
        }
    },
    {
        name: 'bookingsFrontend',
        path: '/bookings',
        component: BookingsFrontend,
        meta: {
            title: 'bookings',
            metaTags: [
                {
                    name: 'description',
                    content: 'bookingsDescription'
                },
                {
                    property: 'og:description',
                    content: 'bookingsDescription'
                }
            ]
        }
    },
    {
        name: 'ShoppingCart',
        path: '/shopping-cart/view',
        component: CartFrontend,
        meta: {
            title: 'ShoppingCart',
            metaTags: [
                {
                    name: 'description',
                    content: 'cartDescription'
                },
                {
                    property: 'og:description',
                    content: 'cartDescription'
                }
            ]
        }
    },
    {
        name: 'CheckoutCart',
        path: '/shopping-cart/checkout',
        component: CheckoutFrontend,
        meta: {
            title: 'CheckoutCart',
            metaTags: [
                {
                    name: 'description',
                    content: 'checkoutDescription'
                },
                {
                    property: 'og:description',
                    content: 'checkoutDescription'
                }
            ]
        }
    },
    {
        name: 'CompleteCart',
        path: '/shopping-cart/:key/complete',
        component: CompleteFrontend,
        meta: {
            title: 'CompleteCart',
            metaTags: [
                {
                    name: 'description',
                    content: 'completeDescription'
                },
                {
                    property: 'og:description',
                    content: 'completeDescription'
                }
            ]
        }
    },
    {
        name: 'UserProfile',
        path: '/profile',
        component: UserProfileFrontend,
        meta: {
            title: 'UserProfile',
            metaTags: [
                {
                    name: 'description',
                    content: 'profileDescription'
                },
                {
                    property: 'og:description',
                    content: 'profileDescription'
                }
            ]
        }
    },
    {
        name: 'ContactFrontend',
        path: '/contact_us',
        component: ContactFrontend,
        meta: {
            title: 'Contact',
            metaTags: [
                {
                    name: 'description',
                    content: 'contactDescription'
                },
                {
                    property: 'og:description',
                    content: 'contactDescription'
                }
            ]
        }
    },
    {
        name: 'RapitaEbroDelta',
        path: '/rapita-ebro-delta',
        component: RapitaEbroDelta,
        meta: {
            title: 'RapitaEbroDelta',
            metaTags: [
                {
                    name: 'description',
                    content: 'RapitaEbroDeltaDescription'
                },
                {
                    property: 'og:description',
                    content: 'RapitaEbroDeltaDescription'
                }
            ]
        }
    },
    {
        name: 'FindUs',
        path: '/find-us',
        component: FindUs,
        meta: {
            title: 'FindUs',
            metaTags: [
                {
                    name: 'description',
                    content: 'FindUsDescription'
                },
                {
                    property: 'og:description',
                    content: 'FindUsDescription'
                }
            ]
        }
    },
    {
        name: 'VideoTour',
        path: '/video-tour',
        component: VideoTour,
        meta: {
            title: 'VideoTour',
            metaTags: [
                {
                    name: 'description',
                    content: 'VideoTourDescription'
                },
                {
                    property: 'og:description',
                    content: 'VideoTourDescription'
                }
            ]
        }
    },
    {
        name: 'SulptureParkGallery',
        path: '/sculpture-park-gallery',
        component: SulptureParkGallery,
        meta: {
            title: 'SulptureParkGallery',
            metaTags: [
                {
                    name: 'description',
                    content: 'SulptureParkGalleryDescription'
                },
                {
                    property: 'og:description',
                    content: 'SulptureParkGalleryDescription'
                }
            ]
        }
    },
    {
        name: 'exhibitionsListFrontend',
        path: '/exhibitions',
        component: ExhibitionsListFrontend,
        meta: {
            title: 'exhibitions',
            metaTags: [
                {
                    name: 'description',
                    content: 'ExhibitionsDescription'
                },
                {
                    property: 'og:description',
                    content: 'ExhibitionsDescription'
                }
            ]
        }
    },
    {
        name: 'exhibitionsViewFrontend',
        path: '/exhibitions/:id',
        component: ExhibitionsViewFrontend,
        meta: {
            title: 'exhibitions',
            metaTags: [
                {
                    name: 'description',
                    content: 'ExhibitionsDescription'
                },
                {
                    property: 'og:description',
                    content: 'ExhibitionsDescription'
                }
            ]
        }
    },
    {
        name: 'RentPark',
        path: '/rent-park',
        component: RentPark,
        meta: {
            title: 'rent_park',
            metaTags: [
                {
                    name: 'description',
                    content: 'RentParkDescription'
                },
                {
                    property: 'og:description',
                    content: 'RentParkDescription'
                }
            ]
        }
    },
    {
        name: 'cookiesViewFrontend',
        path: '/cookies-policy',
        component: CookiesViewFrontend,
        meta: {
            title: 'cookies',
            metaTags: [
                {
                    name: 'description',
                    content: 'CookiesDescription'
                },
                {
                    property: 'og:description',
                    content: 'CookiesDescription'
                }
            ]
        }
    },
    {
        name: 'privacyPolicyViewFrontend',
        path: '/privacy-policy',
        component: PrivacyPolicyViewFrontend,
        meta: {
            title: 'privacy_policy',
            metaTags: [
                {
                    name: 'description',
                    content: 'PrivacyPolicyDescription'
                },
                {
                    property: 'og:description',
                    content: 'PrivacyPolicyDescription'
                }
            ]
        }
    },
    {
        name: 'legalPolicyViewFrontend',
        path: '/legal-policy',
        component: LegalPolicyViewFrontend,
        meta: {
            title: 'legal_policy',
            metaTags: [
                {
                    name: 'description',
                    content: 'LegalPolicyDescription'
                },
                {
                    property: 'og:description',
                    content: 'LegalPolicyDescription'
                }
            ]
        }
    },
    //definir avanç
    {
        name: 'Error404',
        path: '*',
        component: Error404,
        meta: {
            title: '404',
            metaTags: [
                {
                    name: 'description',
                    content: 'notFound'
                },
                {
                    property: 'og:description',
                    content: 'notFound'
                }
            ]
        }
    },
    {
        name: 'shopFrontend',
        path: '/buy-arte',
        component: ShopFrontend,
        meta: {
            title: 'artworks',
            metaTags: [
                {
                    name: 'description',
                    content: 'shopDescription'
                },
                {
                    property: 'og:description',
                    content: 'shopDescription'
                }
            ]
        }
    },
    {
        name: 'photographyCompetitionFrontend',
        path: '/content',
        component: PhotographyCompetitionFrontend,
        meta: {
            title: 'photography_competition',
            metaTags: [
                {
                    name: 'description',
                    content: 'photographyCompetitionDescription'
                },
                {
                    property: 'og:description',
                    content: 'photographyCompetitionDescription'
                }
            ]
        }
    },
    {
        name: 'rapitaEbreFrontend',
        path: '/rapita-ebre',
        component: RapitaEbreFrontend,
        meta: {
            title: 'rapita_ebre',
            metaTags: [
                {
                    name: 'description',
                    content: 'rapitaEbreDescription'
                },
                {
                    property: 'og:description',
                    content: 'rapitaEbreDescription'
                }
            ]
        }
    },
];

export const frontendRoutes = fRoutes;
